export enum looopEnvs {
  ENV_PRODUCTION = 'prod',
  ENV_STAGING = 'staging',
  ENV_UAT = 'uat',
  ENV_TEST = 'test',
  ENV_DEVELOPMENT = 'dev',
  ENV_FEATURE = 'feature'
}

export default {
  is(...envs: string[]) {
    return envs.includes(process.env.LOOOP_ENVIRONMENT as string)
  },
  isProduction() {
    return this.is(looopEnvs.ENV_PRODUCTION)
  },
  isStaging() {
    return this.is(looopEnvs.ENV_STAGING)
  },
  isProductionOrStaging() {
    return this.is(looopEnvs.ENV_STAGING, looopEnvs.ENV_PRODUCTION)
  },
  isDevelopment() {
    return this.is(looopEnvs.ENV_DEVELOPMENT)
  },
  isUAT() {
    return this.is(looopEnvs.ENV_UAT)
  },
  isTest() {
    return this.is(looopEnvs.ENV_TEST)
  },
  isFeature() {
    return this.is(looopEnvs.ENV_FEATURE)
  },
  isPubliclyAccessible() {
    return this.is(
      looopEnvs.ENV_STAGING,
      looopEnvs.ENV_PRODUCTION,
      looopEnvs.ENV_UAT,
      looopEnvs.ENV_FEATURE
    )
  }
}
